<span [innerHTML]="textArray[0]"></span>
<a *ngIf="showHref" class="linkClass" href="{{link}}" target="{{target}}">{{textArray[1]}}</a>
<a *ngIf="showOnClick" class="linkClass" (click)="link()" href="javascript:undefined"><span [innerHTML]="textArray[1]"></span></a>
<span [innerHTML]="textArray[2]"></span>